import React, { ReactElement } from "react";
import { Layout } from "@/components/Layout/Layout";
import { AuthGate } from "@/router/AuthGate";

type Props = {
  children: ReactElement;
};

export const PrivateRoute = ({ children }: Props): ReactElement => {
  return (
    <AuthGate>
      <Layout>{children}</Layout>
    </AuthGate>
  );
};
